import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    title: {
      margin: [10, 0, 2],
      color: theme.palette.neutral.light,
    },
    options: {
      color: theme.palette.neutral.light,
    },
  }),
  { name: "Details" },
);
